import React from 'react';
import { LitElement } from 'lit';
import { createRoot } from 'react-dom/client';
import { StickyBanner } from '@cash-rewards/cr-ui-components';
import { property, customElement } from "lit/decorators.js";
import * as customStyles from "@cash-rewards/cr-ui-components/style.css?inline";

type Variants = 'primary' | 'midnight' | 'black';

@customElement("standalone-stickybanner")
export class Standalonestickybanner extends LitElement {
  @property() 
  text: string = '';
  @property() 
  href: string = '#';

  @property()
  variant?: Variants = 'primary';
  
  @property() 
  actionText?: string;

  @property()
  trackingPixelUrl?: string;

  @property()
  onClose?: () => void;

  @property()
  onClick?: () => void;
  
  @property()
  onRender?: () => void;

  readonly SCRIPT_TAG_ID = 'cr-standalone-sticky-banner-style';

  getVariant(variant: Variants = 'primary'): Variants {
    switch(variant) {
      case 'midnight':
      case 'black':
        return variant;
      case 'primary':
      default:
        return 'primary';
    }
  }

  injectCSS() {
    if (
      typeof document != "undefined" &&
      !this.shadowRoot?.getElementById(this.SCRIPT_TAG_ID)
    ) {
      const elementStyle = document.createElement("style");
      elementStyle.id = this.SCRIPT_TAG_ID;
      elementStyle.appendChild(document.createTextNode(customStyles.default));
      this.shadowRoot?.appendChild(elementStyle);
    }
  }

  override async connectedCallback() {
    super.connectedCallback();
    this.injectCSS();
  }

  override render() {
    const mountPoint = document.createElement('div');
    mountPoint.className = "purple p";
    const root = createRoot(mountPoint);
    root.render(React.createElement(StickyBanner, {
      href: this.href,
      text: this.text,
      actionText: this.actionText,
      variant: this.getVariant(this.variant),
      trackingPixelUrl: this.trackingPixelUrl,
      onClick: this.onClick,
      onClose: this.onClose
    }, null));
    return mountPoint;
  }

  override firstUpdated() {
    if(this.onRender){
      this.onRender();
    }
  }
}
